<script setup lang="ts">
import Modal from '~/components/Common/Modal/Modal.vue';
import AddAvatar from '~/components/Profile/AddAvatar.vue'

defineProps<{
	show: boolean
}>()

const emits = defineEmits(['close'])

</script>

<template>
	<Modal
		:show="show"
		title="Set Your Profile Photo"
		class="max-h-fit"
		boxClass="w-full sm:max-w-xl"
		@close="emits('close')">

		<AddAvatar />

	</Modal>

</template>
